/**
* 用户展示三代锁支持购买的国家有哪些
*/
<template>

	<div style="background-color: #f7f7f7;">


		<van-notice-bar left-icon="volume-o" text="支持购买的国家及地区如下:" />
		<van-notice-bar left-icon="volume-o" text="Countries and regions that support purchase are as follows:" />

		
		<van-index-bar>
			<van-index-anchor index="A" />
			<van-cell title="Algeria" value="阿尔及利亚" />
			<van-cell title="Argentina" value="阿根廷" />
			<van-cell title="Australia" value="澳大利亚" />
			<van-cell title="Austria" value="奥地利" />
			<van-cell title="Argentina" value="阿根廷" />
			<van-cell title="Albania" value="阿尔巴尼亚" />

			<van-index-anchor index="B" />
			<van-cell title="Bangladesh" value="孟加拉国" />
			<van-cell title="Belgium" value="比利时" />
			<van-cell title="Benin" value="贝宁" />
			<van-cell title="Brazil" value="巴西" />
			<van-cell title="Brunei" value="文莱" />
			<van-cell title="Bulgaria" value="保加利亚" />
			<van-cell title="Bangladesh" value="孟加拉国" />

			<van-index-anchor index="C" />
			<van-cell title="Cambodia" value="柬埔寨" />
			<van-cell title="Canada" value="加拿大" />
			<van-cell title="Chile" value="智利" />
			<van-cell title="Chinese mainland" value="中国大陆" />
			<van-cell title="Colombia" value="哥伦比亚" />
			<van-cell title="Congo" value="刚果" />
			<van-cell title="Costa Rica" value="哥斯达黎加" />
			<van-cell title="Croatia" value="克罗地亚" />
			<van-cell title="Czech Republic" value="捷克" />

			<van-index-anchor index="D" />
			<van-cell title="Denmark" value="丹麦" />
			<van-cell title="Dominica" value="多米尼加" />
			<van-cell title="Dong Di Wen" value="东帝文" />

			<van-index-anchor index="E" />
			<van-cell title="El Salvador" value="萨尔瓦多" />
			<van-cell title="Estonia" value="爱沙尼亚" />

			<van-index-anchor index="F" />
			<van-cell title="Faroe Islands" value="法罗群岛" />
			<van-cell title="Fiji" value="斐济" />
			<van-cell title="Finland" value="芬兰" />
			<van-cell title="France" value="法国" />

			<van-index-anchor index="G" />
			<van-cell title="Georgia" value="格鲁吉亚" />
			<van-cell title="Germany" value="德国" />
			<van-cell title="Ghana" value="加纳" />
			<van-cell title="Gibraltar" value="直布罗陀" />
			<van-cell title="Greece" value="希腊" />
			<van-cell title="Guam" value="关岛" />
			<van-cell title="Guatemala" value="危地马拉" />
			<van-cell title="Guernsey" value="根西" />

			<van-index-anchor index="H" />
			<van-cell title="Honduras" value="洪都拉斯" />
			<van-cell title="Hong Kong China" value="中国香港" />
			<van-cell title="Hungary" value="匈牙利" />

			<van-index-anchor index="I" />
			<van-cell title="Iceland" value="冰岛" />
			<van-cell title="India" value="印度" />
			<van-cell title="Indonesia" value="印度尼西亚" />
			<van-cell title="Ireland" value="爱尔兰" />
			<van-cell title="Isle of Man" value="曼岛" />
			<van-cell title="Israel" value="以色列" />
			<van-cell title="Italy" value="意大利" />

			<van-index-anchor index="J" />
			<van-cell title="Japan" value="日本" />
			<van-cell title="Jersey" value="泽西岛" />
			<van-cell title="Jordan" value="约旦" />

			<van-index-anchor index="K" />
			<van-cell title="Kazakhstan" value="哈萨克斯坦斯坦" />
			<van-cell title="Kenya" value="肯尼亚" />
			<van-cell title="Kuwait" value="科威特" />
			<van-cell title="Korea" value="韩国" />

			<van-index-anchor index="L" />
			<van-cell title="Laos" value="老挝" />
			<van-cell title="Latvia" value="拉脱维亚" />
			<van-cell title="Luxembourg" value="卢森堡" />
			<van-cell title="Liechtenstein" value="列支敦士登" />

			<van-index-anchor index="M" />
			<van-cell title="Macau China" value="中国澳门" />
			<van-cell title="Malaysia" value="马来西亚" />
			<van-cell title="Malta" value="马耳他" />
			<van-cell title="Mexico" value="墨西哥" />
			<van-cell title="Mongolia" value="蒙古" />
			<van-cell title="Mozambique" value="莫桑比克" />

			<van-index-anchor index="H" />
			<van-cell title="Netherlands" value="荷兰" />

			<van-index-anchor index="N" />
			<van-cell title="Newzealand" value="新西兰" />
			<van-cell title="Nicaragua" value="尼加拉瓜" />
			<van-cell title="Nigeria" value="尼日利亚" />
			<van-cell title="Norway" value="挪威" />

			<van-index-anchor index="O" />
			<van-cell title="Oman" value="阿曼" />

			<van-index-anchor index="P" />
			<van-cell title="Pakistan" value="巴基斯坦" />
			<van-cell title="Panama" value="巴拿马" />
			<van-cell title="Papua New Guinea" value="巴布亚新几内亚" />
			<van-cell title="Paraguay" value="巴拉圭" />
			<van-cell title="Peru" value="秘鲁" />
			<van-cell title="Poland" value="波兰" />
			<van-cell title="Portugal" value="葡萄牙" />
			<van-cell title="Puerto Rico" value="波多黎各" />

			<van-index-anchor index="R" />
			<van-cell title="Romania" value="罗马尼亚" />
			<van-cell title="Russia" value="俄罗斯" />
			<van-cell title="Republic of Lithuania" value="立陶宛" />

			<van-index-anchor index="S" />
			<van-cell title="Saudi Arabia" value="沙特阿拉伯" />
			<van-cell title="Singapore" value="新加坡" />
			<van-cell title="Slovakia" value="斯洛伐克" />
			<van-cell title="Slovenia" value="斯洛文尼亚" />
			<van-cell title="S.Africa" value="南非" />
			<van-cell title="Spain" value="西班牙" />
			<van-cell title="Sri Lanka" value="斯里兰卡" />
			<van-cell title="Sweden" value="瑞典" />
			<van-cell title="Switzerland" value="瑞士" />

			<van-index-anchor index="T" />
			<van-cell title="Taiwan China" value="中国台湾" />
			<van-cell title="Tanzania" value="坦桑尼亚" />
			<van-cell title="Thailand" value="泰国" />
			<van-cell title="Turkey" value="土耳其" />
			<van-cell title="The Philippines" value="菲律宾" />

			<van-index-anchor index="U" />
			<van-cell title="United States" value="美国" />
			<van-cell title="United Kingdom" value="英国" />
			<van-cell title="Uganda" value="乌干达" />
			<van-cell title="United Arab Emirates" value="阿拉伯联合酋长国" />
			<van-cell title="Uruguay" value="乌拉圭" />
			<van-cell title="Uzbekistan" value="乌兹别克斯坦" />

			<van-index-anchor index="V" />
			<van-cell title="Vietnam" value="越南" />

		</van-index-bar>

	</div>

</template>

<script>
	import 'vant/lib/index.css'; //导入样式
	import Vue from 'vue';
	import {
		IndexBar,
		IndexAnchor,
		Search,
		Cell,
		CellGroup,
		NoticeBar,
	} from 'vant';
	Vue.use(IndexBar);
	Vue.use(IndexAnchor);
	Vue.use(Cell);
	Vue.use(CellGroup);
	Vue.use(Search);
	Vue.use(NoticeBar);


	export default {
		data() {
			return {

			};
		},
	}
</script>

<style>
	.van-cell{
		padding-left: 20px;
		padding-right: 30px;
	}
</style>